import { GetMetaDataResponse, LeroyScene } from '@/store/leroy/Leroy';
import LeroyStore from '@/store/leroy/LeroyStore';
import { _Math } from 'three/src/math/Math';
import generateUUID = _Math.generateUUID;
import { Visualizer } from '@leopoly/arize-eu-insole/dist/visualizer/visualizer';
import { LeoMetadata } from '@leopoly/arize-eu-insole/dist/metadata/metadata-leo';
import { joinPath } from '@/utils';

export default class LeroyManager {
	store: LeroyStore;
	src = '';
	public metadata?: LeoMetadata;
	visualizer?: Visualizer;
	visualizerNode?: HTMLDivElement;
	private platformURL: string;
	public leroySessionID: string = ''; // FIXME(vhermecz) Used to filter stale requests, can be removed

	constructor(state: LeroyStore, platformURL: string) {
		this.store = state;
		this.leroySessionID = generateUUID();
		this.platformURL = platformURL;
	}

	public setVisualizerNode(node?: HTMLDivElement) {
		this.visualizerNode = node;
		this.resetVisualizer(!!node);
	}

	public resetVisualizer(init = true) {
		if (this.visualizer) return;
		this.visualizer = undefined;
		if (this.visualizerNode !== undefined) {
			this.visualizerNode.querySelectorAll('div').forEach((div) => {
				this.visualizerNode?.removeChild(div);
			});
		}
		if (init) {
			const enablerServiceUrl = joinPath(this.platformURL, 'api/v1/enablerservice/forwardcall');
			const enablerServiceBearerTokenGetter = () => this.store.store.auth.token;
			this.visualizer = new Visualizer({ enablerServiceUrl, enablerServiceBearerTokenGetter });
			this.visualizer.rootNode.style.position = '';
			this.visualizer.rootNode.style.width = '';
			this.visualizer.rootNode.style.height = '';
			this.visualizerNode?.appendChild(this.visualizer.rootNode);
			// hack: To have the same css class as LeroyModal
			const vueCssClass = Array.from(this.visualizerNode?.attributes || []).filter((x) => x.name.startsWith('data-v'))[0];
			if (vueCssClass) {
				this.visualizer.rootNode.setAttribute(vueCssClass.name, vueCssClass.value);
			}
		}
	}

	public async setScene(scene: LeroyScene) {
		console.log('HP-119: setScene in action');
		const leftScanData = this.store.store.biometric.buildVisualizerFootScan('leftscan');
		const rightScanData = this.store.store.biometric.buildVisualizerFootScan('rightscan');
		// LeroyUtils.saveFile(new Blob([leftScanData?.fileBytes || new Uint8Array()]), 'leftfoot.drc');
		// LeroyUtils.saveFile(new Blob([rightScanData?.fileBytes || new Uint8Array()]), 'rightfoot.drc');
		console.log(['setSCENE', scene]);
		console.log(['setSCENE LEFT', leftScanData]);
		console.log(['setSCENE RIGHT', rightScanData]);
		if (!this.visualizer) {
			return false;
		}
		if (scene === 'InsoleVisualizer') {
			return await this.visualizer.setInsoleInspectionScene({
				insoleParameters: {
					type: 'metadata-leo',
					metadata: this.metadata || {}
				},
				leftScanData,
				rightScanData
			});
			//console.log(["HP SCENE INSOLE", result]);
		} else {
			return await this.visualizer.setLandmarkScene({
				left: leftScanData,
				right: rightScanData,
				landmarks: {
					type: 'from-leo-metadata',
					metadata: this.metadata || {}
				},
				onLandmarkChanged: (metadata) => {
					this.store.onLandmarksChanged(metadata);
					metadata = JSON.parse(JSON.stringify(metadata));
					console.log(['LANDMARK changed', metadata]);
				}
			});
			//console.log(["HP SCENE LAND", result]);
		}
	}

	public async applyMetadata() {
		await this.visualizer?.applyMetadata(this.metadata || {});
	}
}
